import React, { useState } from 'react'
import { useModal } from '../contexts/ModalContext'
import FormularioRD from '../rdstation/formularioRD'
import Container from './container'

export default function AccordionInnovation({
  title,
  description,
  items,
  imageSrc,
  origem,
}) {
  const [activeItem, setActiveItem] = useState(0)
  const { openModal } = useModal()

  return (
    <div className="w-full bg-[#040116] py-18 relative overflow-hidden">
      {/* Background com grafismos */}
      <div className="absolute inset-0 opacity-10 flex justify-end">
        <img
          src="/assets/grafismos2.png"
          alt="Grafismos"
          className="h-full object-contain object-right-top"
        />
      </div>

      <Container className="relative z-10 flex flex-col gap-6 lg:flex-row lg:gap-16">
        <div>
          <div>
            <header className="lg:hidden">
              {title && (
                <h2 className="font-inter-light text-white text-4xl lg:text-5xl mb-4 text-center">
                  {title}
                </h2>
              )}
              {description && (
                <p className="font-inter-regular text-sm md:text-xl text-white mb-8 text-center">
                  {description}
                </p>
              )}
            </header>
            {origem === 'solutions' ? (
              <div className="">
                <h2 className="font-inter-light text-5xl mb-4 text-white">
                  Entregas{' '}
                  <span className="bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB] text-transparent bg-clip-text">
                    de valor
                  </span>
                </h2>
                <div className="relative overflow-hidden w-[359px]">
                  <img
                    src={imageSrc}
                    alt=""
                    className="block w-full rounded-lg mt-4"
                  />
                  <div className="bg-[rgba(66,19,147,0.7)] rounded-[25px] py-4 px-5 flex items-center gap-6 absolute bottom-0 mb-4 mx-4">
                    <h3 className="font-inter-light w-full text-white">
                      Otimize <br /> seu negócio!
                    </h3>

                    <button
                      type="button"
                      onClick={() => openModal(<FormularioRD />)}
                      className="font-poppins-light text-sm flex items-center gap-2 py-2 px-8 rounded-full bg-gradient-to-r from-[#4B3BDB] via-[#4B3BDB] to-[#A002CB] text-white hover:scale-105 transition duration-300 cursor-pointer"
                    >
                      Contratar{' '}
                      <svg
                        width="15"
                        height="15"
                        viewBox="0 0 15 15"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <title>svg</title>
                        <path
                          d="M3.64645 11.3536C3.45118 11.1583 3.45118 10.8417 3.64645 10.6465L10.2929 4L6 4C5.72386 4 5.5 3.77614 5.5 3.5C5.5 3.22386 5.72386 3 6 3L11.5 3C11.7761 3 12 3.22386 12 3.5L12 9C12 9.27614 11.7761 9.5 11.5 9.5C11.2239 9.5 11 9.27614 11 9L11 4.70711L4.35355 11.3536C4.15829 11.5488 3.84171 11.5488 3.64645 11.3536Z"
                          fill="currentColor"
                          fillRule="evenodd"
                          clipRule="evenodd"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="mt-8">
                <img src={imageSrc} className="w-full rounded-lg" alt="" />
              </div>
            )}
          </div>
        </div>

        {/* Coluna da direita - 2/3 */}
        <div className="lg:w-2/3 lg:ml-auto my-auto">
          <header className="hidden lg:block">
            {title && (
              <h2 className="font-inter-light text-white text-5xl mb-4">
                {title}
              </h2>
            )}
            {description && (
              <p className="font-inter-regular text-xl text-white mb-8">
                {description}
              </p>
            )}
          </header>
          {items.map((item, index) => (
            <div
              key={index}
              className={`border-t ${
                origem === 'solutions' ? 'border-[#4B3BDB]' : 'border-[#FC0021]'
              } py-6`}
              onClick={() => setActiveItem(index)}
            >
              <div className="flex items-center justify-between cursor-pointer">
                <div className="flex items-center gap-4">
                  <span className="text-white text-inter-regular text-xl">
                    {item.id}
                  </span>
                  <h3 className="text-white font-inter-bold text-sm md:text-xl tracking-wider">
                    {item.title}
                  </h3>
                </div>
                <button
                  type="button"
                  className={`w-8 h-8 rounded-full flex items-center justify-center transition-colors ${
                    activeItem === index
                      ? origem === 'solutions'
                        ? 'bg-[#4B3BDB]'
                        : 'bg-[#FC0021]'
                      : ''
                  }`}
                >
                  {activeItem === index ? (
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 14 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <title>svg</title>
                      <path d="M7 0L13.9282 7.5H0.0717969L7 0Z" fill="white" />
                    </svg>
                  ) : (
                    <svg
                      width="10"
                      height="10"
                      viewBox="0 0 14 8"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                      className="rotate-180"
                    >
                      <title>svg</title>
                      <path d="M7 0L13.9282 7.5H0.0717969L7 0Z" fill="white" />
                    </svg>
                  )}
                </button>
              </div>
              <div
                className={`overflow-hidden transition-all duration-500 ease-in-out ${
                  activeItem === index
                    ? 'max-h-[200px] opacity-100'
                    : 'max-h-0 opacity-0'
                }`}
              >
                <div className="mt-4 pl-10 text-white text-xs md:text-base pr-8 font-inter-light">
                  {item.description}
                </div>
              </div>
            </div>
          ))}
        </div>
      </Container>
    </div>
  )
}
